import { styled, Box } from "@mui/material";

export const PaperWrapper = styled(Box)({
    width: "500px",
    background: 'white',
    height: '900px',
    borderRadius: '30px',
    padding: '100px 150px',
});